import { render, staticRenderFns } from "./DocumentPDFPreview.vue?vue&type=template&id=cecceee8"
import script from "./DocumentPDFPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPDFPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports